import { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { user } from "../classes/user";
import axios from '../services/axios-config';

const UserAuthContext = createContext();



export const UserAuthProvider = ({children}) => {

    const router = useNavigate();

    const [userAuth, setUserAuth] = useState(() => {
        const value = localStorage.getItem('auth');
        return value ? true : false;
    });

    const login = () => {
        localStorage.setItem('auth', true);
        setUserAuth(true);
        router('/home');
    }
    
    const logout = async () => {
        await axios.post('/auth/logout');
        localStorage.removeItem('auth');
        localStorage.removeItem('admin_token');
        setUserAuth(false);
        user.insert(null);
        router('/');
    }

    return(
        <UserAuthContext.Provider value={{userAuth, setUserAuth, login, logout}}>
            {children}
        </UserAuthContext.Provider>
    )
}

export default UserAuthContext;